import { ProductDetails, FilterDetails, DownloadProductFile, ValidateFormNumber, AifPmsWatchList, CommonBankMaster, } from "@domains/features/Markets/AIF-PMS/useCases/AifPmsUseCase";
import { DeletedDraftDocsUseCase, DraftOrderCountUseCase, DraftOrderDeclarationsUseCase, DraftOrderDetailsUseCase, DraftOrderUpdateUseCase, GetDraftOrdersUseCase, PreviewDocsUseCase, SaveDraftDocsUseCase, SaveDraftOrdersUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/DraftOrderUseCase";
import { BookmarkUseCase, BookmarkWatchlistUseCase, MultiBookmarkUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/BookmarkUseCase";
import { DocsUseCase, OrderListUseCase, OrdersUseCase, EmpPartnerDetailsUseCase, OrdersDetailUseCase, ValidateFormUseCase, OrderDeclarationsUseCase, MultidocsUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/PurchaseUseCase";
import { AggregatedHoldingUseCase, FolioDetailsUseCase, HoldingQtyDetailsUseCase, HoldingSummaryUseCase, RecentClientSearchGetUseCase, RecentClientSearchSaveUseCase, TrxTypeListUseCase, UccClientSearchUseCase, UccCodeClientSearchUseCase, UserPopupStatusSaveUseCase, UserPopupStatusUseCase, ValidateClientUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/GlobalUseCase";
import { OrderBookDetailsUseCase, OrderBookDownloadUseCase, OrderBookListUseCase, OrderBookUpdateLeadUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/OrderBookUseCase";
import { PartnerLeadUseCase, SbSearchUseCase, SearchLeadUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/LeadServiceUseCase";
import { AssignToSelfUseCase, DocumentDetailsUseCase, DocumentListUseCase, ModifyTransactionUseCase, PendingTransactionsByIdUseCase, PendingTransactionsUseCase, UpdateApproveRejectStatusUseCase, FolioDetailsUseCase as QCFolioDetailsUseCase, PendingCountUseCase, DownloadPendingTransactionUseCase, UploadDocsUseCase, DeleteDocsUseCase, } from "@domains/features/Markets/AIF-PMS/useCases/QualityCheckUseCase";
export default (function (repositories) {
    return {
        aifPms: {
            watchList: new AifPmsWatchList(repositories.aifPms),
            validateFormNumber: new ValidateFormNumber(repositories.aifPms),
            productDetails: new ProductDetails(repositories.aifPms),
            filterDetails: new FilterDetails(repositories.aifPms),
            bookmark: new BookmarkUseCase(repositories.aifPms),
            bookmarkWatchlist: new BookmarkWatchlistUseCase(repositories.aifPms),
            downloadProductFile: new DownloadProductFile(repositories.aifPms),
            multiBookmark: new MultiBookmarkUseCase(repositories.aifPms),
            commonBankMaster: new CommonBankMaster(repositories.aifPms),
        },
        payment: undefined,
        purchase: {
            orders: new OrdersUseCase(repositories.purchase),
            orderList: new OrderListUseCase(repositories.purchase),
            empPartnerDetails: new EmpPartnerDetailsUseCase(repositories.purchase),
            docs: new DocsUseCase(repositories.purchase),
            orderDetails: new OrdersDetailUseCase(repositories.purchase),
            validateForm: new ValidateFormUseCase(repositories.purchase),
            orderDeclarations: new OrderDeclarationsUseCase(repositories.purchase),
            multidocs: new MultidocsUseCase(repositories.purchase),
        },
        draft: {
            getDraftOrderCount: new DraftOrderCountUseCase(repositories.draft),
            getDraftOrders: new GetDraftOrdersUseCase(repositories.draft),
            saveDraftOrders: new SaveDraftOrdersUseCase(repositories.draft),
            draftOrderDetails: new DraftOrderDetailsUseCase(repositories.draft),
            draftOrderUpdate: new DraftOrderUpdateUseCase(repositories.draft),
            deletedDraftDocs: new DeletedDraftDocsUseCase(repositories.draft),
            previewDocs: new PreviewDocsUseCase(repositories.draft),
            saveDraftDocs: new SaveDraftDocsUseCase(repositories.draft),
            draftOrderDeclarations: new DraftOrderDeclarationsUseCase(repositories.draft),
        },
        global: {
            recentClientSearchGet: new RecentClientSearchGetUseCase(repositories.global),
            recentClientSearchSave: new RecentClientSearchSaveUseCase(repositories.global),
            trxTypeList: new TrxTypeListUseCase(repositories.global),
            userPopupStatus: new UserPopupStatusUseCase(repositories.global),
            userPopupStatusSave: new UserPopupStatusSaveUseCase(repositories.global),
            validateClient: new ValidateClientUseCase(repositories.global),
            holdingSummary: new HoldingSummaryUseCase(repositories.global),
            folioDetails: new FolioDetailsUseCase(repositories.global),
            holdingQtyDetails: new HoldingQtyDetailsUseCase(repositories.global),
            aggregatedHolding: new AggregatedHoldingUseCase(repositories.global),
            uccClientSearch: new UccClientSearchUseCase(repositories.global),
            uccCodeClientSearch: new UccCodeClientSearchUseCase(repositories.global),
        },
        orderBook: {
            orderbookdetails: new OrderBookDetailsUseCase(repositories.orderBook),
            orderbooklist: new OrderBookListUseCase(repositories.orderBook),
            downloadorderbook: new OrderBookDownloadUseCase(repositories.orderBook),
            updateleadorderbook: new OrderBookUpdateLeadUseCase(repositories.orderBook),
        },
        leadservice: {
            partnerLead: new PartnerLeadUseCase(repositories.leadservice),
            sbSearch: new SbSearchUseCase(repositories.leadservice),
            searchLead: new SearchLeadUseCase(repositories.leadservice),
        },
        qualityCheck: {
            pendingTransactions: new PendingTransactionsUseCase(repositories.qualityCheck),
            pendingTransactionsById: new PendingTransactionsByIdUseCase(repositories.qualityCheck),
            assignToSelf: new AssignToSelfUseCase(repositories.qualityCheck),
            updateApproveRejectStatus: new UpdateApproveRejectStatusUseCase(repositories.qualityCheck),
            documentList: new DocumentListUseCase(repositories.qualityCheck),
            documentDetails: new DocumentDetailsUseCase(repositories.qualityCheck),
            modifyTransaction: new ModifyTransactionUseCase(repositories.qualityCheck),
            folioDetails: new QCFolioDetailsUseCase(repositories.qualityCheck),
            pendingCount: new PendingCountUseCase(repositories.qualityCheck),
            downloadPendingTransaction: new DownloadPendingTransactionUseCase(repositories.qualityCheck),
            uploadDocs: new UploadDocsUseCase(repositories.qualityCheck),
            deleteDocs: new DeleteDocsUseCase(repositories.qualityCheck),
        },
    };
});
